import axios from 'axios';
import { Message } from '../api';
import { storeType } from '../redux/store';
import { setNotification } from '../utils/notificationUtils';
import { handle401 } from './401Handler';
import { ERROR, FORM_VALIDATION } from '../layouts/notification/Notification';
import { StatusCodes } from 'http-status-codes';
import { handle5xx } from './5xxHandler';
import { handle4xx } from './4xxHandler';
import jwtDecode from 'jwt-decode';

export const initializeHttpClient = (store: storeType) => {
  axios.defaults.headers['Content-Type'] = 'application/json';

  axios.interceptors.response.use(
    response => response,
    async err => {
      if (err && err.response) {
        const errorDto: Message[] = err.response?.data;
        if (
          err.response.status == StatusCodes.UNAUTHORIZED &&
          errorDto &&
          errorDto[0]?.severity != FORM_VALIDATION
        ) {
          return handle401(err);
        } else if (
          err.response.status == StatusCodes.INTERNAL_SERVER_ERROR ||
          err.response.status == StatusCodes.INSUFFICIENT_STORAGE
        ) {
          handle5xx(store, err);
        } else if (err.response.status.toString().startsWith('4')) {
          handle4xx(store, err);
        }
      } else {
        setNotification('Server nicht erreichbar', [], ERROR, null);
      }
      return Promise.reject(err);
    }
  );

  axios.interceptors.request.use(async request => {
    request.headers.languageId = '0';

    const token = localStorage.getItem('token');
    if (token) {
      const decodedToken: any = jwtDecode(token);
      request.headers.languageId = JSON.parse(decodedToken['language-id']);
      request.headers.Authorization = token;
    }

    if (process.env.NODE_ENV === 'production')
      request.url = request.url?.replace('http://localhost/don/api', BASE_URL);
    return request;
  });
};

const BASE_URL =
  process.env.NODE_ENV === 'production'
    ? '/don/api'
    : 'http://localhost/don/api';

export const URL_KARTE =
  process.env.NODE_ENV === 'production' ? '/' : 'http://localhost/';
